<template>
	<ActivityBadgeLayout class="assignment-change-activity-badge">
		<FontAwesomeIcon :icon="[ `fas`, `user-tag` ]" />
	</ActivityBadgeLayout>
</template>

<script>
import ActivityBadgeLayout from "./ActivityBadgeLayout";
export default {
	name: "AssignmentChangeActivityBadge",
	components: {
		ActivityBadgeLayout,
	},
};
</script>

<style lang="scss" scoped>
$badgeColor: $color1-500;
$badgeBackgroundColor: $color1-100;

.assignment-change-activity-badge {
	background-color: $badgeBackgroundColor;

	* {
		color: $badgeColor;
	}
}
</style>
